export default __webpack_public_path__ + "static/media/error.6b9e6b66.png";